import React from 'react';
import { Search } from 'lucide-react';

export default function SearchBar({ value, onChange, placeholder }) {
  return (
    <div className="flex-1 relative flex items-center border border-locate2-border-light rounded-lg focus-within:border-locate2-primary focus-within:ring-1 focus-within:ring-locate2-primary transition-colors">
      <Search
        size={18}
        className="absolute left-3 text-locate2-muted pointer-events-none"
      />
      <input
        type="text"
        placeholder={placeholder || 'Search...'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-10 pr-4 py-2.5 bg-transparent text-locate2-medium-gray text-sm placeholder:text-locate2-muted focus:outline-none"
      />
    </div>
  );
}
